import * as React from "react";

// MUI
import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { Button, Grid, GridProps, Typography } from "@material-ui/core";

// NPM
import clsx from "clsx";
import { animated } from "react-spring";
import moment from "moment";

// Classes
import Utility from "../../domain/classes/Utility";

// Contexts
// import { useJourneyManager } from "../../contexts/JourneyManager.Context";

// Enums
import JourneyStage from "../../domain/enums/JourneyStage";

// Interfaces
import IAvailableSlot from "../../domain/interfaces/IAvailableSlot";

// Classes
import DateTime from "../../domain/classes/DateTime";
// import { useDoctorManager } from "../../contexts/DoctorManager.Context";
// import Doctor from "../../domain/classes/Doctor";
import { useApplicationManager } from "../../contexts/ApplicationManager.Context";
import IDoctor from "../../domain/interfaces/IDoctor";
import AppointmentBookingRequest from "../../domain/classes/AppointmentBookingRequest";
import IAppointmentRecord from "../../domain/interfaces/IAppointmentRecord";

export const styles = (theme: Theme) =>
	createStyles({
		root: {},
		duration: { textTransform: "lowercase", marginLeft: theme.spacing(1) },
	});

export interface AppointmentSlotProps extends GridProps {
	availSlot: IAvailableSlot;
	drData: IDoctor;
	apptRec: IAppointmentRecord;
	minDuration: number;
}

const AppointmentSlot = React.forwardRef<
	HTMLDivElement,
	AppointmentSlotProps & WithStyles<typeof styles>
>(({ className, classes, availSlot, drData, apptRec, minDuration }, ref) => {
	// Contexts
	// const { handleJourneyStageChange } = useJourneyManager();
	// const { handleSelectedDoctorChange, doctors } = useDoctorManager();

	const {
		handleJourneyStageChange,
		handleSelectedDoctorChange,
		appointmentBookingRequest,
		handleAppointmentBookingRequestChange,
	} = useApplicationManager();

	// Handlers
	const handleAppointmentSlotSelected = () => {
		// const dr = Doctor.getDoctorByBPId(availSlot.UserId.toString(), doctors);
		handleSelectedDoctorChange(drData);
		handleAppointmentBookingRequestChange(
			AppointmentBookingRequest.parseAppointment(
				availSlot,
				apptRec,
				appointmentBookingRequest
			)
		);
		handleJourneyStageChange(JourneyStage.PersonalDetailsInput);
	};

	return (
		<Grid item xs={12} className={clsx(className, classes.root)} ref={ref}>
			<Button fullWidth onClick={handleAppointmentSlotSelected}>
				<Typography variant="body1" color="primary">
					<strong>
						{moment(availSlot.startDateTime).format(
							DateTime.TIME_DISPLAY_FORMAT
						)}
					</strong>
				</Typography>
				<span className={classes.duration}>({minDuration} mins)</span>
			</Button>
		</Grid>
	);
});

const StyledAppointmentSlot = withStyles(styles, {
	classNamePrefix: Utility.generateClassName("AppointmentSlot"),
})(AppointmentSlot);

export default StyledAppointmentSlot;

export const AnimatedAppointmentSlot = animated(StyledAppointmentSlot);
